import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_UTILS; // || 'https://dev-api.hirewing.ca/admin';

const authApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

authApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/ats/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  // Login & Session Management
  login: async (email, password, rememberMe = false) => {
    const response = await authApi.post(
      process.env.REACT_APP_GET_ACCESS_TOKEN,
      {
        username: email,
        password: password,
      }
    );
    return response.data;
  },

  logout: async () => {
    const response = await authApi.post('/mgmt/auth/token/logout');
    return response.data;
  },

  getCurrentUser: async () => {
    return true; // Temporary bypass for authentication
    // const response = await authApi.get('/auth/me');
    // return response.data;
  },

  // Password Management
  completePasswordChallenge: async (newPassword, username) => {
    const response = await authApi.post('/mgmt/auth/cognitoconfirmpassword', {
      username: username,
      password: newPassword,
    });
    return response.data;
  },

  changePassword: async (email, newPassword) => {
    const response = await authApi.post('/mgmt/auth/confirmpassword', {
      username: email,
      newpassword: newPassword,
    });
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await authApi.post('/mgmt/auth/ForgotPassword', {
      username: email,
    });
    return response.data;
  },

  verifyOtp: async (email, otp, newPassword) => {
    const response = await authApi.post('/mgmt/auth/confirmCode', {
      username: email,
      code: otp,
      temppassword: newPassword,
    });
    return response.data;
  },

  resendOtp: async (email) => {
    const response = await authApi.post('/auth/resend-otp', {
      email,
    });
    return response.data;
  },

  // User Registration
  register: async (userData) => {
    const response = await authApi.post('/auth/register', userData);
    return response.data;
  },

  verifyEmail: async (email, verificationCode) => {
    const response = await authApi.post('/auth/verify-email', {
      email,
      verificationCode,
    });
    return response.data;
  },
};

export default authApi;
